import { useEffect, useRef, useState } from "react";
import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
import { stepVisuals } from "./DifferenceVisuals";
export function Difference() {
  const t = useT();
  const [active, setActive] = useState(0);
  const refs = useRef([]);
  useEffect(() => {
    const io = new IntersectionObserver(entries => {
      for (const e of entries) {
        if (e.isIntersecting) {
          const idx = Number(e.target.dataset['step']);
          setActive(idx);
        }
      }
    }, {
      rootMargin: "-45% 0px -45% 0px",
      threshold: 0
    });
    refs.current.forEach(el => el && io.observe(el));
    return () => io.disconnect();
  }, []);
  const ActiveVisual = stepVisuals[active] ?? stepVisuals[0];
  return <section id="unterschied" className="bg-[#FAFBFC] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <Reveal>
          <h2 className="max-w-2xl text-2xl font-bold text-[#0F172A] sm:text-3xl">
            {t.different.title}
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#64748B]">
            {t.different.lead}
          </p>
        </Reveal>

        {/* Desktop: sticky Visual, Text läuft daran vorbei */}
        <div className="mt-14 hidden gap-12 lg:grid lg:grid-cols-2">
          <div>
            {t.different.steps.map((step, i) => <div key={step.title} data-step={i} ref={el => {
            refs.current[i] = el;
          }} className="flex min-h-[70vh] flex-col justify-center">
                <p className="text-xs font-semibold tracking-[0.18em] uppercase transition-colors" style={{
              color: active === i ? "#3B82F6" : "#CBD5E1"
            }}>
                  {step.kicker}
                </p>
                <h3 className="mt-3 text-xl font-semibold transition-colors sm:text-2xl" style={{
              color: active === i ? "#0F172A" : "#CBD5E1"
            }}>
                  {step.title}
                </h3>
                <p className="mt-4 max-w-lg text-base leading-relaxed text-[#64748B]">
                  {step.body}
                </p>
              </div>)}
          </div>
          <div className="relative">
            <div className="sticky top-28">
              <div className="rounded-3xl border border-black/5 bg-white p-6 shadow-[0_18px_50px_rgba(10,37,57,0.08)]">
                <ActiveVisual />
              </div>
              <div className="mt-4 flex gap-1.5" aria-hidden>
                {t.different.steps.map((s, i) => <span key={s.title} className="h-1 flex-1 rounded-full transition-colors" style={{
                backgroundImage: i === active ? "linear-gradient(90deg,#3B82F6,#93C5FD)" : undefined,
                backgroundColor: i === active ? undefined : "rgba(10,37,57,0.1)"
              }} />)}
              </div>
            </div>
          </div>
        </div>

        {/* Mobil: gestapelt, jeder Schritt mit eigenem Visual */}
        <div className="mt-12 space-y-12 lg:hidden">
          {t.different.steps.map((step, i) => {
          const Visual = stepVisuals[i] ?? stepVisuals[0];
          return <Reveal key={step.title}>
                <p className="text-xs font-semibold tracking-[0.18em] text-[#3B82F6] uppercase">
                  {step.kicker}
                </p>
                <h3 className="mt-2 text-lg font-semibold text-[#0F172A]">{step.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#64748B]">{step.body}</p>
                <div className="mt-5 rounded-3xl border border-black/5 bg-white p-5">
                  <Visual />
                </div>
              </Reveal>;
        })}
        </div>

      </div>
    </section>;
}